<template>
  <OfferExpandedDetails
    :criteria-options="{lot:{show: false}}"
    :item="item"/>
</template>
<script>
import OfferExpandedDetails from 'components/tenders/tender page/offersGroups/OfferExpandedDetails.vue'

export default {
  name: 'offersParticipantGroupTableDetails',
  components: {
    OfferExpandedDetails,
  },
  props: {
    item: {
      type: Object
    },
    tender: {
      type: Object
    },
  },
}
</script>
